module.exports = __webpack_public_path__ + "img/InnovationIcon.d9660b95.svg";